import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Defer Clarity until after the page is interactive to avoid blocking LCP/FID
const initClarity = () => {
  import('@microsoft/clarity').then(({ default: clarity }) => {
    clarity.init("x8fbl45g69");
  });
};

// Load after first user interaction or after 5 seconds, whichever comes first
if (document.readyState === 'complete') {
  setTimeout(initClarity, 5000);
} else {
  window.addEventListener('load', () => {
    const events = ['mousedown', 'touchstart', 'keydown', 'scroll'];
    const onInteraction = () => {
      initClarity();
      events.forEach(e => window.removeEventListener(e, onInteraction));
    };
    events.forEach(e => window.addEventListener(e, onInteraction, { once: true, passive: true }));
    // Fallback: load after 5s even with no interaction
    setTimeout(initClarity, 5000);
  }, { once: true });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
